"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HAS_ALPHA_CHARACTER_REGEX = exports.ALPHA_NUM_SPACE_REGEX = exports.POSTAL_CODE_REGEX = exports.NAME_REGEX = exports.EMAIL_VALIDATOR_REGEX = void 0;
exports.EMAIL_VALIDATOR_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
exports.NAME_REGEX = /^[\p{L}\p{M} ]+$/gu;
exports.POSTAL_CODE_REGEX = /^[\p{L}\p{M} 0-9-]+$/u;
exports.ALPHA_NUM_SPACE_REGEX = /^[a-z0-9 ]+$/i;
exports.HAS_ALPHA_CHARACTER_REGEX = /[a-zA-Z]/;
